<template>
  <div class="page-order-record page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="12">
          <h3 style="float: none;">订单记录</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置:</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>支付管理</el-breadcrumb-item>
              <el-breadcrumb-item>订单记录</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block">
          <el-form :inline="true" :model="search_form" class="demo-form-inline">
            <el-form-item label="姓名:">
              <el-input size="small" v-model="search_form.travelerName" placeholder="请输入出差人员姓名"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="费用类型:">
              <el-select size="small" v-model="search_form.feeType" placeholder="请选择费用类型" clearable
                         style="width:150px;">
                <el-option label="用餐" value="用餐"></el-option>
                <el-option label="用车" value="用车"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付状态:">
              <el-select size="small" v-model="search_form.payStatus" placeholder="请选择支付状态" clearable
                         style="width:150px;">
                <el-option label="待支付" :value="0"></el-option>
                <el-option label="已支付" :value="1"></el-option>
                <el-option label="已退款" :value="2"></el-option>
                <el-option label="已取消" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间:">
              <el-date-picker size="small" v-model="search_form.payTime" type="daterange" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                              clearable style="width:240px;"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
              <el-button size="small" @click="handleReset">重置</el-button>
              <el-button size="small" type="success" @click="handleExport">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark"
                      style="width: 100%;text-align: center;">
              <el-table-column prop="orderNo" align="center" label="订单号" min-width="190"></el-table-column>
              <el-table-column prop="travelerName" align="center" label="姓名" min-width="120"></el-table-column>
              <el-table-column prop="travelerOrgName" align="center" label="单位/部门"
                               min-width="120"></el-table-column>
              <el-table-column prop="feeType" align="center" label="费用类型" min-width="140"></el-table-column>
              <el-table-column align="left" label="明细" min-width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.attach">
                    <div v-for="(item, index) in parseAttach(scope.row.attach)" :key="index" style="line-height: 1.8;">
                      {{ item.name }}({{ item.usedate }})：¥{{ item.money }}
                    </div>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" align="center" label="订单金额" min-width="120">
                <template slot-scope="scope">
                  ¥{{ scope.row.amount }}
                </template>
              </el-table-column>
              <el-table-column prop="payStatus" align="center" label="支付状态" min-width="100">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.payStatus === 0" type="warning">待支付</el-tag>
                  <el-tag v-else-if="scope.row.payStatus === 1" type="success">已支付</el-tag>
                  <el-tag v-else-if="scope.row.payStatus === 2" type="info">已退款</el-tag>
                  <el-tag v-else-if="scope.row.payStatus === 3" type="danger">已取消</el-tag>
                </template>
              </el-table-column>
              <!--							<el-table-column prop="payType" align="center" label="支付方式" min-width="120">
                              <template slot-scope="scope">
                                <span v-if="scope.row.payType === 1">JSAPI</span>
                                <span v-else-if="scope.row.payType === 2">委托代扣</span>
                                <span v-else>-</span>
                              </template>
                            </el-table-column>-->
              <el-table-column prop="transactionId" align="center" label="微信交易单号"
                               min-width="200"></el-table-column>
              <el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
            </el-table>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]"
                         :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
                         :total="table_data.page_info.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/assets/js/config';
export default {
  name: 'orderRecordList',
  data() {
    return {
      body_loading: false,
      search_form: {
        travelerName: '',
        feeType: '',
        payStatus: '',
        payTime: []
      },
      table_data: {
        loading: false,
        list: [],
        page_info: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  created() {
    document.title = '订单记录';
    this.getList();
  },
  methods: {
    getList() {
      var _this = this;
      var params = {
        pageNo: _this.table_data.page_info.page,
        pageSize: _this.table_data.page_info.pageSize,
        travelerName: _this.search_form.travelerName,
        feeType: _this.search_form.feeType,
        payStatus: _this.search_form.payStatus,
        startDate: _this.search_form.payTime && _this.search_form.payTime[0] ? _this.search_form.payTime[0] : '',
        endDate: _this.search_form.payTime && _this.search_form.payTime[1] ? _this.search_form.payTime[1] : ''
      };
      _this.table_data.loading = true;
      this.$client.get('/api/biz/business/traveler/order/getList', params, function (res, message, total) {
        _this.table_data.list = res;
        _this.table_data.page_info.total = total;
        _this.table_data.loading = false;
      }, function (res) {
        _this.table_data.loading = false;
      });
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    handleSearch() {
      this.table_data.page_info.page = 1;
      this.getList();
    },
    handleReset() {
      this.search_form.travelerName = '';
      this.search_form.feeType = '';
      this.search_form.payStatus = '';
      this.search_form.payTime = [];
      this.table_data.page_info.page = 1;
      this.getList();
    },
    handleExport() {
      var _this = this;
      var params = {
        travelerName: _this.search_form.travelerName,
        feeType: _this.search_form.feeType,
        payStatus: _this.search_form.payStatus,
        startDate: _this.search_form.payTime && _this.search_form.payTime[0] ? _this.search_form.payTime[0] : '',
        endDate: _this.search_form.payTime && _this.search_form.payTime[1] ? _this.search_form.payTime[1] : ''
      };
      var queryString = Object.keys(params).map(key => params[key] !== '' ? `${key}=${encodeURIComponent(params[key])}` : '').filter(Boolean).join('&');
      if (queryString) {
        queryString += '&'
      }
      console.log(queryString);
      window.open(config.api_url + '/api/biz/business/traveler/order/export?' + queryString + 'token=' + localStorage.getItem('token') + '&loginFrom=pc', '_blank');
    },
    parseAttach(attach) {
      try {
        const data = typeof attach === 'string' ? JSON.parse(attach) : attach;
        return data.items || [];
      } catch (e) {
        return [];
      }
    }
  }
}
</script>
<style scoped>
.search-block {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
}
</style>
